import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AdminService} from "../../../../services/admin.service";
import {TreeNode} from "primeng/primeng";
import {QuestionSpecializationModel} from "../models/learning.model";

@Injectable()
export class SpecializationsService {

  public nodes: TreeNode[] = [];
  public nodeId = '';
  public nodeName = '';
  public nodeType = '';
  public nodePosition = '';

  public positions = [];
  public selectedPositionId = '';
  public selectedPositionName = 'No position';

  public noSpecializations = false;
  public getSpecializationsError = false;

  public createSpecSuccess = false;
  public updateSpecSuccess = false;
  public updateSpecGroupSuccess = false;
  public fileUploadFailed = false;

  private allQuestionsValid: boolean;
  private validFullQ: number;
  private validEmptyQ: number;

  private somethingMissing: number;
  public isOperationAccepted =  false;
  constructor(private http: HttpClient, private adminService: AdminService) {
  }

  getAllSpecs() {
    return this.adminService.getAllSpecs();
  }

  getSingleSpec() {
    return this.adminService.getSpecById(this.nodeId);
  }

  getNodes(): TreeNode[] {
    return this.nodes;
  }

  setNodes(value: TreeNode[]) {
    this.nodes = value;
  }

  updateTree() {
    this.getAllSpecs().subscribe(
      (response: any) => {
        if (response.status === 204) {
          this.noSpecializations = true;
        }
        if (response.status === 200) {
          this.setNodes(response.body);
          this.noSpecializations = false;
        }
      },
      () => {
        this.getSpecializationsError = true;
      }
    );
  }

  clearNodeSelection() {
    this.nodeId = '';
    this.nodeName = '';
    this.nodeType = '';
  }

  validateQuestions(questions: QuestionSpecializationModel[]) {
    this.validFullQ = 0;
    this.validEmptyQ = 0;
    this.allQuestionsValid = true;
    questions.forEach(question => {
      // Full question valid
      if (question.questionText.trim().length > 0) {
        if (question.rightAnswer.answerText.trim().length < 1) {
          this.allQuestionsValid = false;
        } else {
          let ansValidCount = 0;
          question.answers.forEach(answer => {
            if (answer.answerText.trim().length < 1) {
              this.allQuestionsValid = false;
            } else {
              ansValidCount++;
            }
          });
          if (ansValidCount === question.answers.length) {
            this.validFullQ++;
          }
        }
      } else {
        // Valid because of empty
        if (question.rightAnswer.answerText.trim().length > 0) {
          this.allQuestionsValid = false;
        } else {
          let emptyAnsValidCount = 0;
          question.answers.forEach(answer => {
            if (answer.answerText.trim().length > 1) {
              this.allQuestionsValid = false;
            } else {
              emptyAnsValidCount++;
            }
          });
          if (emptyAnsValidCount === question.answers.length) {
            this.validEmptyQ++;
          }
        }
      }
    });
    if (this.validFullQ > 0 && this.validEmptyQ > 0) {
      this.allQuestionsValid = false;
    }
    return this.allQuestionsValid;
  }

  checkEmptyInput(questions: QuestionSpecializationModel[]) {
    this.somethingMissing = 0;
    questions.forEach(question => {
      if (question.questionText.trim().length > 0) {
        if (question.rightAnswer.answerText.trim().length < 1) {
          this.somethingMissing++;
        } else {
          question.answers.forEach(answer => {
            if (answer.answerText.trim().length < 1) {
              this.somethingMissing++;
            }
          });
        }
      } else {
        this.somethingMissing++;
      }
    });
    return this.somethingMissing;
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/specializations/services/specializations.service.ts